import React from 'react';
import { SvgProps } from 'models/Icon';

export default (props: SvgProps) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="transparent"
    stroke="currentColor"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M10.667 7.33333V4.66667C10.667 3.19391 9.47308 2 8.00033 2C6.52757 2 5.33366 3.19391 5.33366 4.66667V7.33333M3.33366 6H12.667L13.3337 14H2.66699L3.33366 6Z" />
  </svg>
);
